import { atom } from 'jotai';

export const notificationsMarkedAllReadAtAtom = atom<number | null>(null);
